import script from "./EditTinymceBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTinymceBox.vue?vue&type=script&setup=true&lang=js"

import "./EditTinymceBox.vue?vue&type=style&index=0&id=a1c756cc&lang=scss"

const __exports__ = script;

export default __exports__